import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import loginImage from '../resources/login.jpg';

const LoginPage = ({ isLoggedIn, setIsLoggedIn }) => {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = (event) => {
        event.preventDefault();

        // Hardcoded credentials for demo purposes
        // const validEmail = 'admin@example.com';
        // const validPassword = 'password';

        if ((email === 'rommel' && password === 'Fantastic.4') ||
            (email === 'dhanua' && password === 'fatabichi') ||
            (email === 'priyantan' && password === '9051962436@inspire') ||
            (email === 'neha' && password === 'Fantastic.4')) {
            // Redirect to dashboard after successful login
            history.push('/dashboard');
            setIsLoggedIn(true);
            localStorage.setItem('isLoggedIn', 'true');
        } else {
            setError('Invalid email or password');
        }
    };

    return (
        <Container fluid className="vh-100">
            <Row className="h-100">
                <Col md={6} className="bg-image d-none d-md-flex align-items-center justify-content-center" style={{ backgroundImage: `url(${loginImage})`, backgroundSize: 'cover' }}>
                    {/* Add your image background */}
                </Col>
                <Col md={6} className="login-form d-flex align-items-center justify-content-center">
                    <div className="card shadow-2-strong" style={{ borderRadius: '1rem' }}>
                        <div className="card-body p-5 text-center">
                            <h3 className="mb-5">Sign in</h3>
                            <Form>
                                {error && <div className="text-danger mb-3">{error}</div>}
                                <Form.Group controlId="formEmail">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="mb-3"
                                    />
                                </Form.Group>
                                <Form.Group controlId="formPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="mb-3"
                                    />
                                </Form.Group>
                                <Button variant="primary" type="submit" onClick={handleLogin} block className="mb-3">
                                    Login
                                </Button>
                                <div className="text-center">
                                    <small className="text-muted">Forgot password?</small>
                                </div>
                                <hr />
                                <div className="text-center">
                                    <small>
                                        Don't have access? <a href="mailto:admin@inspirestudio.org?subject=Require%20access%20to%20Data%20Visualization%20Dashboard&body=Please%20provide%20access%20to%20the%20current%20mailid%20to%20the%20data%20visualization%20dashboard.">Request Access</a>
                                    </small>
                                </div>
                            </Form>

                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default LoginPage;
